import { render } from "./ProductMainsubsection.vue?vue&type=template&id=ccb12a44&scoped=true"
import script from "./ProductMainsubsection.vue?vue&type=script&lang=js"
export * from "./ProductMainsubsection.vue?vue&type=script&lang=js"

import "./ProductMainsubsection.vue?vue&type=style&index=0&id=ccb12a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb12a44"]])

export default __exports__